import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=d1f617bc&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=d1f617bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f617bc",
  null
  
)

export default component.exports